import { tv } from 'tailwind-variants'

export const selectableButton = tv({
  base: 'transition-all cursor-pointer ring-1 hover:shadow-md active:shadow-md',
  variants: {
    selected: {
      true: 'ring-neutral-700 dark:ring-neutral-300',
      false: 'ring-neutral-50 dark:ring-neutral-900',
    },
    variant: {
      card: 'bg-neutral-100 dark:bg-neutral-700 rounded-lg',
      segment: '',
    },
  },
  defaultVariants: {
    selected: false,
    variant: 'card',
  },
})
